/**
 * A source id such as "crowdstrike_falcon" as a person would write it: "CrowdStrike Falcon". Only the text on screen
 * changes; filters, sorting keys and the data keep the id.
 */

/** Words that are not written as plain Title Case: acronyms and product names. */
const WORDS: Record<string, string> = {
  aws: 'AWS',
  gcp: 'GCP',
  id: 'ID',
  s3: 'S3',
  crowdstrike: 'CrowdStrike',
  cloudtrail: 'CloudTrail',
  guardduty: 'GuardDuty',
  paloalto: 'Palo Alto',
  servicenow: 'ServiceNow',
  okta: 'Okta',
  entra: 'Entra',
  prisma: 'Prisma',
  splunk: 'Splunk',
  zscaler: 'Zscaler',
  fortinet: 'Fortinet',
  jira: 'Jira',
};

export function sourceLabel(id: string | undefined | null): string {
  const raw = String(id ?? '').trim();
  if (!raw) return '';
  // Already written for people ("CrowdStrike Falcon", "AWS CloudTrail"): leave it.
  if (/[A-Z\s]/.test(raw)) return raw;
  return raw
    .split(/[_\-\s]+/)
    .filter(Boolean)
    .map((word) => WORDS[word] ?? word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/** "CrowdStrike Falcon / Okta", or a dash when there is none. */
export function sourcesLine(ids: string[]): string {
  return ids.length ? ids.map(sourceLabel).join(' / ') : '—';
}
